import { beforeEnterMicrofrontend } from '@/router/routes/business/inventory/utils/beforeEnterMicrofrontend'

export default [
  {
    path: ':path(sales.*)?',
    name: 'inventory.sales',
    beforeEnter: beforeEnterMicrofrontend('sales'),
    component: () => import('@/views/business/inventory/sales/iframe-service.vue'),
  },
]
